import { TranslateService } from "./../../shared/translate/translate.service";
import { AuthService } from "./../../shared/models/auth.service";
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  OnChanges
} from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Router } from "@angular/router";
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL,
  UserRoles,
  DataListModel,
  IKeyValueInterface
} from "../../shared/config";
import {
  OrganizationDriverModel,
  OrganizationDriverMappingModel,
  OrganizationDriverPersonModel
} from "../models/organization-driver.model";
import { OrganizationDriverService } from "../models/organization-driver.service";

@Component({
  selector: "wego-assign-driver-to-organization-popup",
  template: require('../views/organization-driver-popup.component.html')
})
export class AssignOrganizationDriverPopupComponent
  implements OnInit, OnChanges {
  DataListModel: DataListModel;
  driverList: OrganizationDriverModel[];
  model: OrganizationDriverPersonModel;
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;
  isParentCheck: boolean;
  LblAssignDriver: string;
  LblIcon: string;
  isNewDriver: number = 1;
  errorModel: IKeyValueInterface[];

  public OrganizationHashId: string;
  @Output("OnSuccessSelect") onSuccessSelect = new EventEmitter();
  @ViewChild("driverPopupModel") public driverPopupModel: any;

  get isAnyChecked(): boolean {
    if (this.driverList) {
      let isCheck = this.driverList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.driverList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else this.isParentCheck = false;
      } else {
        this.isParentCheck = false;
      }
      return isCheck;
    } else {
      this.isParentCheck = false;
      return false;
    }
  }
  constructor(
    private organizationDriverService: OrganizationDriverService,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.LblAssignDriver =
      this.translate.instant("LblAssign") + this.translate.instant("LblDriver");
    this.LblIcon = "fa fa-plus-square";
    this.isNewDriver = 1;
    this.DataListModel = new DataListModel();
    this.model = new OrganizationDriverPersonModel();
    this.DataListModel.searchField = ["driverName", "firstName", "lastName"];
  }

  ngOnChanges(change: any) {
    console.log(change);
  }

  public show(): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.GetDriverListForOrganization();
    this.isNewDriver = 1;
    this.model.userName = "";
    this.model.emailAddressModel.email = "";
    this.errorModel = [];
    this.driverPopupModel.show();
  }

  public hide(): void {
    this.driverPopupModel.hide();
  }

  private GetDriverListForOrganization() {
    this.isLoading = true;
    this.organizationDriverService
      .GetDriverListByOrganizationToInstance(
        this.OrganizationHashId,
        this.DataListModel
      )
      .subscribe(
        res => {
          this.driverList = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public OnParentCheck(isChecked: boolean) {
    this.driverList.forEach(x => (x.isChecked = isChecked));
  }

  private select(driverHashId: string): void {
    this.isLoading = true;
    let model = new OrganizationDriverMappingModel();
    model.driverHashId = driverHashId;
    model.organizationHashId = this.OrganizationHashId;
    this.organizationDriverService.AssignDriverToOrganization(model).subscribe(
      res => {
        this.message = this.translate.instant("LblRecordSavedSuccess");
        this.OnSuccessSelect();
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      },
      () => {
        this.driverPopupModel.hide();
        this.isLoading = false;
      }
    );
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetDriverListForOrganization();
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetDriverListForOrganization();
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetDriverListForOrganization();
  }

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetDriverListForOrganization();
  }
  private OnSuccessSelect() {
    this.onSuccessSelect.emit({ SuccessMessage: this.message });
  }

  private OnAdd(event: any) {
    let driverHashIdList: any[];
    driverHashIdList = this.driverList
      .filter(x => x.isChecked)
      .map(x => x.driverMasterHashId);
    this.isLoading = true;
    let model = new OrganizationDriverMappingModel();
    model.listOfDriverHashId = driverHashIdList;
    model.organizationHashId = this.OrganizationHashId;
    this.organizationDriverService.AssignDriverToOrganization(model).subscribe(
      res => {
        this.message = this.translate.instant("LblRecordSavedSuccess");
        this.OnSuccessSelect();
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      },
      () => {
        this.driverPopupModel.hide();
        this.isLoading = false;
      }
    );
  }

  public AddNewPerson() {
    this.model.organizationHashId = this.OrganizationHashId;
    this.organizationDriverService.AddPerson(this.model).subscribe(
      res => {
        if (res.data) {
          // this.popupMsg = this.translate.instant('LblRecordAddedSuccess', [this.module]);
          // this.ShowSuccessPopup();
          this.OnSuccessSelect();
          this.isLoading = false;
          this.hide();
        } else {
          this.errorModel = res.error;
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/organizationdriver/components/organization-driver-popup.component.ts